module.exports = __webpack_public_path__ + "static/media/bubble.4cc8870a.png";